import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const extraCashbackAdd = createAsyncThunk("extraCashback/extraCashbackAdd", async ({ channelId, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`channel/${channelId}/unitDetails`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

//initial state
const initialState = {
	isLoading: false,
	isError: false,
	error: null,
	data: null,
};

//redux slice
const CreateExtraCashbackSlice = createSlice({
	name: "CreateExtraCashbackSlice",
	initialState,
	reducers: {
		resetExtraCashbackAddState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(extraCashbackAdd.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(extraCashbackAdd.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(extraCashbackAdd.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetExtraCashbackAddState } = CreateExtraCashbackSlice.actions;
export default CreateExtraCashbackSlice.reducer;
